import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputNumber, InputSwitch, InputPicklist, InputRating } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './transactiondetail-model';  //editable..
import ProductPicklist from '../product/product-picklist.component';
import ProductList from '../product/product-list.component';
import SchedulePicklist from '../schedule/schedule-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactiondetailEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        
        this.onChange = this.onChange.bind(this);
    }
    
    private validations = [...Model.validations, {}];

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
        this.validations = [...Model.validations, {name: 'qty', maxValue: data?.productQty }];
    }
    
    private onLoadProduct = (data: any) => {
        const pricetype = this.state.datarow.transactiontypePricetype || 'pricesale';
        const price = pricetype === 'pricesale'? data?.pricesale : data?.pricebase;
        
        this.setState({ datarow: 
            new Model({ ...this.state.datarow, 
                'product': data, 'price': price, 'value': price * this.state.datarow.qty, 
                'schedule': null, 'startdate': data.scheduleLength === 0? AppService.dateCurrent() : AppService.dateISO(data.startdate, '', 1)
            }) 
        });
                
        this.validations = [...Model.validations, {name: 'qty', maxValue: data?.qty }];
        if (data.scheduleLength > 0) 
            this.validations = [...this.validations, { name: 'schedule', required: true }];
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: {...this.state.datarow, 'schedule': data?.id, 'scheduleCaption': data?.name, 'scheduleDisableday': data?.disableDay, 'startdate': data?.availableDate}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onChange(fieldName: string, value?: string) { 
        var  valueField = this.state.datarow.value;
        if (fieldName==='price') valueField= this.state.datarow.qty * Number(value)
        else if (fieldName==='qty') valueField= this.state.datarow.price * Number(value)

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, value: valueField,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                endPointFilter={Model.endPointFilter2} model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError} validations={this.validations}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputDate name='startdate' label='Date' value={this.state.datarow.startdate} error={this.state.errors?.startdate} onChange={this.onChange} />
                <InputPicklist name='product' label='Product' value={this.state.datarow.product} caption={this.state.datarow.productCaption} error={this.state.errors?.product} onChange={this.onChange} >
                    <ProductPicklist currentId={this.state.datarow.product} pricetype={this.state.datarow.transactiontypePricetype} onLoad={this.onLoadProduct}/>
                </InputPicklist>
                <InputMoney name='price' label='Price' value={this.state.datarow.price} error={this.state.errors?.price} onChange={this.onChange} />
                <InputNumber name='qty' label='Qty' value={this.state.datarow.qty} error={this.state.errors?.qty} onChange={this.onChange}/>
                <InputMoney name='value' label='Total' value={this.state.datarow.price * this.state.datarow.qty} error={this.state.errors?.value} readOnly />
                {this.state.datarow.productProducttypeType === 'events' &&
                <>
                {this.state.datarow.productSchedule?.length > 0 &&
                <InputPicklist name='schedule' label='Schedule' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                    <SchedulePicklist productId={this.state.datarow.product} currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule}/>
                </InputPicklist>
                }
                {this.state.datarow.productSchedule?.length === 0 &&
                <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} error={this.state.errors?.startdate} onChange={this.onChange}/>            
                }
                {this.state.datarow.schedule > 0 &&
                <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} error={this.state.errors?.startdate} disablePast disableTime disableDay={this.state.datarow.scheduleDisableday} onChange={this.onChange}/>            
                }
                </>
                }
                {this.state.datarow.productProductLength > 0 &&
                    <ProductList history={this.props.history} caption='Sub Product' parentId={this.state.datarow.product} actions={[]} disableBackButton/>
                }
                {this.state.datarow.transactionStatus === 'approved' &&
                <>
                <InputRating name='rating' label='Rating' value={this.state.datarow.rating} size='large' error={this.state.errors?.comment} onChange={this.onChange}/>
                <InputMultiline name='comment' label='Comment' value={this.state.datarow.comment} error={this.state.errors?.comment} onChange={this.onChange} />
                </>
                }
            </BaseEdit>
        );
    }
}